export const SHIPMENT_ID_OPTIONAL_BU_CODES = new Set(["DSDE064", "DT208", "DT318", "TEST"]);
export const GATE_ASSIGNMENT_BU_CODES = new Set(["DSDE064", "DT208", "DT318"]);
export const SIMULATOR_ADVANCED_BU_CODES = new Set(["TEST", "TEST01", "TEST02"]);

export const DEV_HOSTNAME = "dev.loadmstr.ingka.com";
export const PROD_HOSTNAME = "loadmstr.ingka.com";

export function isGateAssignmentBuCode(buCode: string | string[] | undefined) {
  const normalizedBuCode = Array.isArray(buCode) ? buCode[0] : buCode;
  return normalizedBuCode ? GATE_ASSIGNMENT_BU_CODES.has(normalizedBuCode.toUpperCase()) : false;
}

export const LANDING_PAGE_BU_LIST = [
  {
    code: "DT208", // previously "DSDE064"
    name: "(208) Dortmund",
  },
  {
    code: "DT318",
    name: "(318) Wels",
  },
];

export const buList = [
  {
    code: "DCTJ012",
    name: "(012) Tianjin",
    isCn: true,
  },
  {
    code: "DT208", // previously "DSDE064"
    name: "(208) Dortmund",
  },
  {
    code: "DCSJ",
    name: "(258) Songjiang",
    isCn: true,
  },
  {
    code: "DT318",
    name: "(318) Wels",
  },
];
